import styled from "styled-components"
import Grid from "./grid"

export const Container = styled(Grid.Item)``
Container.defaultProps = {
  gridColumn: "inqury-info-start / inqury-info-end",
  order: [1, 1, 2],
}
